/* eslint-disable @typescript-eslint/ban-ts-comment */
import { format as formatDate, isDate } from 'date-fns';
import { ptBR, enUS } from 'date-fns/locale';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { makeZodI18nMap } from 'zod-i18n-map';

import zodBR from './zod.json';

export const locales = { ptBR, enUS };

export const supportedLngs = [
  {
    value: 'pt-BR',
    label: 'Português',
  },
  {
    value: 'en',
    label: 'English',
  },
];

const detectLanguage = (): string => {
  const storedLanguage = localStorage.getItem('i18nextLng');
  if (!storedLanguage) {
    localStorage.setItem('i18nextLng', 'pt-BR');
    return 'pt-BR';
  }

  return storedLanguage;
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(Backend)
  .init({
    fallbackLng: detectLanguage(),
    supportedLngs: supportedLngs.map(lng => lng.value),
    ns: ['common'],
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (isDate(value) && format && lng) {
          // @ts-ignore
          const locale = locales[lng] || ptBR;

          return formatDate(value, format, { locale });
        }

        return value;
      },
    },
    backend: {
      loadPath: '../../../../locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'path', 'querystring', 'navigator'],
      lookupFromPathIndex: 0,
    },
  });

i18n.init({
  partialBundledLanguages: true,
  resources: {
    'pt-BR': {
      zod: zodBR,
    },
  },
});

z.setErrorMap(makeZodI18nMap());

export const changeLanguage = (language: string) => {
  localStorage.setItem('i18nextLng', language);
  i18n.changeLanguage(language);
};

export default i18n;
